const severities = {
    critical: 1,
    high: 2,
    medium: 3,
    low: 4
};
function severitySortType(rowA, rowB, columnId) {
    const keyA = getRowValueByColumnID(rowA, columnId);
    const keyB = getRowValueByColumnID(rowB, columnId);
    const a = severities[keyA] || 0;
    const b = severities[keyB] || 0;
    return compareBasic(a, b);
}
function stringsSortType(rowA, rowB, columnId) {
    const a = getRowValueByColumnID(rowA, columnId);
    const b = getRowValueByColumnID(rowB, columnId);
    if (typeof a === 'string' && typeof b === 'string') {
        return compareBasic(a.toLowerCase(), b.toLowerCase());
    }
    /* istanbul ignore next - fallback, shouldn't be called */
    return compareBasic(a, b);
}
function arrayOfStringsSortType(rowA, rowB, columnId) {
    const a = getRowValueByColumnID(rowA, columnId);
    const b = getRowValueByColumnID(rowB, columnId);
    if (Array.isArray(a) && Array.isArray(b)) {
        return compareBasic(a.join(', ').toLowerCase(), b.join(', ').toLowerCase());
    }
    /* istanbul ignore next - fallback, shouldn't be called */
    return compareBasic(a, b);
}
function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function getRowValueByColumnID(row, columnId) {
    return row.values[columnId];
}

export { arrayOfStringsSortType, compareBasic, getRowValueByColumnID, severitySortType, stringsSortType };
//# sourceMappingURL=sortTypes.esm.js.map
